export const SPEECH_LANGUAGES = ['en-US', 'zh-CN', 'ja-JP', 'ko-KR', 'zh-TW']

export const SpeechEvents = {
  recognizing: 'recognizing',
  recognized: 'recognized',
  error: 'error',
  started: 'started',
  stopped: 'stopped'
} as const

// Renew the Azure token when fewer than this many ms remain before it expires.
export const TOKEN_EXPIRY_BUFFER_MS = 60_000
// Fallback lifetime when the JWT exp claim cannot be parsed (Azure tokens live ~10 min).
export const TOKEN_FALLBACK_TTL_MS = 9 * 60_000
// Periodic in-session refresh so long recognitions survive token expiry.
export const TOKEN_REFRESH_INTERVAL_MS = 8 * 60_000
